import { cva } from 'class-variance-authority'

export const listCustomBulletsStyles = cva('flex flex-col gap-4', {
  variants: {
    variant: {
      icon: '',
      number: '',
      image: '',
    },
  },
})

export const listCustomBulletsItemStyles = cva('', {
  variants: {
    variant: {
      icon: 'flex items-start gap-3',
      number: 'flex items-start gap-3',
      image: 'flex items-center gap-2',
    },
  },
})

export const numberIndicatorStyles = cva(
  'flex items-center justify-center rounded-full flex-shrink-0 label-sm w-6 h-6'
)

export const imageThumbnailStyles = cva(
  'flex-shrink-0 rounded overflow-hidden w-16 h-16'
)
